import {ContainerModule} from '@yosmanyga/di';

import {PaymentController,} from './';

const DI = new ContainerModule((bind) => {
    bind(PaymentController).toSelf();
});

export {DI};
